import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlarmClockOff, TimerReset } from "lucide-react";

const left = (deadline) => Math.max(0, Math.floor((new Date(deadline).getTime() - Date.now()) / 1000));

const clock = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

const tone = (seconds) =>
  seconds <= 600
    ? "bg-destructive/10 text-destructive"
    : seconds <= 1800
      ? "bg-amber-500/10 text-amber-600"
      : "bg-primary/10 text-primary";

// عدّاد إغلاق نافذة الانصراف: بعد انتهائه يُسجَّل اليوم غياباً لعدم تسجيل الانصراف.
export const CheckoutCountdown = ({ record }) => {
  const { t } = useTranslation();
  const deadline = record?.checkout_deadline;
  const [seconds, setSeconds] = useState(() => (deadline ? left(deadline) : 0));

  useEffect(() => {
    if (!deadline) return undefined;
    setSeconds(left(deadline));
    const timer = setInterval(() => setSeconds(left(deadline)), 1000);
    return () => clearInterval(timer);
  }, [deadline]);

  if (record?.status === "absent" && record?.absence_reason === "no_check_out") {    return (
      <p className="mt-2 flex items-center gap-2 rounded-xl bg-destructive/10 px-3 py-2 text-[13px] font-bold text-destructive"
         data-testid="checkout-window-closed">
        <AlarmClockOff className="h-4 w-4 shrink-0" /> {t("check.checkoutClosed")}
      </p>
    );
  }
  if (!deadline || record?.check_out_at || !record?.check_in_at) return null;

  return (
    <p className={`mt-2 flex items-center gap-2 rounded-xl px-3 py-2 text-[13px] font-bold ${tone(seconds)}`}
       data-testid="checkout-countdown">
      <TimerReset className="h-4 w-4 shrink-0" />
      {seconds > 0 ? (
        <span>
          {t("check.checkoutWindow")} <span className="font-mono" data-testid="checkout-countdown-value">{clock(seconds)}</span>
        </span>
      ) : (
        t("check.checkoutWindowOver")
      )}
    </p>
  );
};
